import map from "lodash/map";
import { WizardSteps } from "PFComponents/wizard_steps";
import { useTranslation } from "react-i18next";

import { useRollForwardWizardNavigation } from "../../hooks/use_roll_forward_wizard_navigation";
import { ROLL_FORWARD_WIZARD_STEP_ORDER, RollForwardWizardStep } from "../../roll_forward_wizard.constants";
import { ROLL_FORWARD_WIZARD_STEPS } from "../../roll_forward_wizard_steps";

export const WizardProgress = () => {
  const { t } = useTranslation("workflow", { keyPrefix: "parts.rollForwardWizard" });
  const { activeStep, isStepReachable, goTo } = useRollForwardWizardNavigation();

  const steps = map(ROLL_FORWARD_WIZARD_STEP_ORDER, (step) => ({
    id: step,
    title: t(ROLL_FORWARD_WIZARD_STEPS[step].titleKey),
    qaId: ROLL_FORWARD_WIZARD_STEPS[step].qaId
  }));

  const handleStepClick = (stepId: string) => goTo(stepId as RollForwardWizardStep);
  const isStepDisabled = (index: number) => !isStepReachable(index);

  return (
    <WizardSteps
      steps={steps}
      activeStepId={activeStep}
      onStepClick={handleStepClick}
      isStepDisabled={isStepDisabled}
    />
  );
};
